import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToolbarModule } from '../public/toolbar/toolbar.module';
import { PrivacyPolicyComponent } from './privacy-policy.component';
import { NewFooterModule } from '../public/new-footer/new-footer.module';

@NgModule({
  declarations: [PrivacyPolicyComponent],
  exports: [PrivacyPolicyComponent],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: PrivacyPolicyComponent
      }
    ]),
    ToolbarModule,
    NewFooterModule
  ]
})
export class PrivacyPolicyModule {}
